<p-table
  #dt
  [value]="columns"
  [paginator]="true"
  [rows]="10"
  [tableStyle]="{ 'min-width': '50rem' }"
  [rowsPerPageOptions]="[10, 25, 500]"
  [resizableColumns]="true"
  columnResizeMode="expand"
  styleClass="p-datatable-striped"
>
  <ng-template pTemplate="caption">
    <div class="flex">
      <p-skeleton shape="circle" size="3rem" styleClass="mr-2" />
      <p-skeleton shape="circle" size="3rem" styleClass="mr-2" />
      <p-skeleton shape="circle" size="3rem" styleClass="mr-2" />
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let item of dataSets; let i = index" [pSortableColumn]="item.field" style="width:20%">{{ item.header }} <p-sortIcon [field]="item.field"></p-sortIcon></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body">
    <tr>
      <td *ngFor="let item of [].constructor(length); let i = index"><p-skeleton height=".5rem" /></td>
    </tr>
  </ng-template>

</p-table>

